"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LazyLoadError = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const constants_1 = require("../components/CashierPaymentsWidget/constants");
const LazyLoadError = () => (react_1.default.createElement("div", { role: "alert", "data-hook": "pw-lazy-load-error" // intentionally not in DataHook.ts to avoid bundling all the data hooks into TPAs bundle
    , 
    // this component gets bundled inside TPAs bundle by their yoshi/webpack config, and .scss might not be supported, thus using css-in-js
    style: {
        // same styles as in general error message
        fontFamily: 'orig_wix_madefor_text_regular, Noto Sans Hebrew, Avenir Next, Helvetica Neue, Helvetica, Arial',
        fontSize: '14px',
        lineHeight: '20px',
        backgroundColor: '#fff',
        color: '#000',
    } },
    react_1.default.createElement("div", { style: {
            backgroundColor: 'rgb(223, 49, 49, 0.1)',
            padding: '10px 16px',
        } }, constants_1.initErrorMessage)));
exports.LazyLoadError = LazyLoadError;
//# sourceMappingURL=LazyLoadError.js.map